
import channelIO from "@/assets/js/channel-io";
import { default as CommonUtils, default as commonUtils } from "@/common-utils";
import SearchForm from "@/components/SearchForm.vue";
import TermsPop1 from "@/views/biz-kr/member/TermsPop1.vue";
import TermsPop2 from "@/views/biz-kr/member/TermsPop2.vue";
import axios from "axios";
import throttle from "lodash-es/throttle";
import { Component, Vue, Watch } from "vue-property-decorator";
import Constants from "../../constants";
import { BannerMasterVO, MstMenuVO } from "../biz/main/vo/main.vo";
import { BrandVO } from "../biz/menu/vo/brand.vo";
import { CategoryVO } from "../biz/menu/vo/category.vo";
import Terms from "@/views/biz/privacy/Terms.vue";
import PrivacyPolicy from "@/views/biz/privacy/PrivacyPolicy.vue";
import CommonModalDialog from "@/components/CommonModalDialog.vue";
import { MstPointHistoryVO } from "../biz/mypage/vo/mypage.vo";

// 글로벌에서만 채팅 사용함
let channel;
if (CommonUtils.isSystemLocale("global") == true) {
  channel = new channelIO();
}
@Component({ components: { SearchForm, TermsPop1, TermsPop2, CommonModalDialog, Terms, PrivacyPolicy } })
export default class LayoutMain extends Vue {
  // 앱설치유도팝업
  appInstallPromptPop = false;
  showTerms1 = false;
  showTerms2 = false;
  menuIdx = 0;
  isAsideFixed = false; // aside 배너 고정임?
  banners = [] as Array<BannerMasterVO>;

  openedTotalMenu = false; // 전체메뉴(PC용)
  currentTotalMenu = ""; // 01: 카테고리, 02: 브랜드

  categories = [] as Array<CategoryVO>; // 카테고리
  categoryOneDepth = {} as CategoryVO;
  categoryTwoDepth = {} as CategoryVO;

  currentInitial = "";
  brands = [] as Array<BrandVO>; // 브랜드

  asideLeftBannerSwiperOption = {
    pagination: { el: ".swiper-pagination", type: "fraction" },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  asideRightBannerSwiperOption = {
    pagination: { el: ".swiper-pagination", type: "fraction" },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: 3,
    direction: "vertical",
    slidesPerGroup: 3,
    spaceBetween: 6,
    height: 270,
  };

  // 알림설정 팝업 관련
  isSendedNotiPoint = [] as Array<boolean>;
  sumPoint = [] as Array<number>;
  mailingType = [] as Array<string>;
  showNotificationPointPopup = false;

  // 플로팅배너 클릭 여부
  isClickedFloatingBanner = false;

  get isMobileWeb() {
    const userAgent = navigator.userAgent.toLowerCase();
    return this.$isMobile && userAgent.indexOf("zikoo") == -1 && userAgent.indexOf("chiclyn") == -1;
  }

  // 좌 사이드 배너 있음?
  get leftBanner() {
    return this.banners.filter((item) => item.bannerTypeCd == "052002");
  }

  // 우 사이드 배너 있음?
  get rightBanner() {
    return this.banners.filter((item) => item.bannerTypeCd == "052003");
  }

  // 플로팅 배너(안 닫은 애들만)
  get floatingBanners() {
    // 플로팅 배너가 표시되길 원하는 라우트명을 입력해 줌
    const filterRoute = "Promotion, Main";
    const routeName = this.$route.name ? this.$route.name : "";

    const floatingBanners = this.banners.filter((item) => {
      if (item.bannerTypeCd == "052001" && this.isNotClosedFloatingBanner(item.bannerCd) == true && filterRoute.indexOf(routeName) != -1) {
        //모바일 시 이미지가 없으면 안보여지게
        if(this.$isMobile && item.fileUrl){
          return item;
        } else if(!this.$isMobile && (item.fileUrl || item.fileUrl2)) {
          return item;
        }
      }
    });

    return floatingBanners;
  }
  // 세션 회원 정보
  get member() {
    return this.$session.get(Constants.MEMBER_INFO);
  }

  // 최근 본 상품
  get recentProducts() {
    return this.$store.state.recentProducts;
  }

  // 카테고리 2뎁스
  get getCategoryTwoDepth() {
    return this.categories.filter((category) => category.cateDepth == 2 && this.categoryOneDepth.cateCd == category.parentCateCd);
  }

  // 카테고리 3뎁스
  get getCategoryThreeDepth() {
    return this.categories.filter((category) => category.cateDepth == 3 && this.categoryTwoDepth.cateCd == category.parentCateCd);
  }

  // 브랜드 이니셜
  get brandInitials(): Array<string> {
    return Array.from(new Set(this.brands.map((b) => (b.brandEngNm || "#").toUpperCase().charAt(0)))).sort();
  }

  // 브랜드 이니셜 offset
  get slideToOffset() {
    // 일단은 강제로 넣었는데, 나중에 offset 가져와서 융통성있게 ㄱㄱ
    return -165;
  }

  // 메뉴 고정
  handleScroll = throttle(this.handleTopNavigation, 50);
  handleTopNavigation(): void {
    // 상단 메뉴
    // PC웹은 상단 배너 떄문에 Constants.MENU_POSITION_TOP 못씀
    const menuWrap = document.getElementsByClassName("main-menu-wrap")[0] as HTMLElement;
    if (!menuWrap) {
      return;
    }
    const menuPositionTop = menuWrap.offsetTop + 1;
    // aside
    let asidePositionBottom = menuPositionTop;
    if (!this.$isMobile && this.$route.name == "Main") {
      const visualizationArea = document.getElementsByClassName("visualization-area")[0] as HTMLElement;
      const floatingBanner = document.getElementsByClassName("floating-banner")[0] as HTMLElement;
      visualizationArea && (asidePositionBottom = visualizationArea.offsetTop + visualizationArea.offsetHeight);
      // 플로팅배너가 있으면
      if (floatingBanner) {
        asidePositionBottom += floatingBanner.offsetHeight;
      }
    }
    try {
      if (menuPositionTop <= window.scrollY) {
        this.$store.commit("isTopMenuFixed", true);
      } else {
        this.$store.commit("isTopMenuFixed", false);
      }

      if (asidePositionBottom <= window.scrollY) {
        this.isAsideFixed = true;
      } else {
        this.isAsideFixed = false;
      }
    } catch (e) {
      // ignore
      return;
    }
  }

  // 불편하지만 웹으로 보기(24시간)
  closePop() {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    commonUtils.putLocalStorageObject(Constants.APP_INSTALL_HIDDEN_TODAY, date);
    this.appInstallPromptPop = false;
  }

  // ZIKOO 앱으로 보기
  goAppInstall() {
    location.href = `https://zikoo.co.kr/zlink`
  }

  goNotificationPoint(){
    this.showNotificationPointPopup = false;
    this.closeNotificationPointPop();
    this.$router.push({ name: "MypageProfile" });
  }

  // 앱 설치 유도 팝업
  // - 오늘 하루 보지 않기 클릭하면 팝업 안함
  initAppInstallPromptPop() {
    // 오늘 하루 보지 않기 클릭 시점
    const appInstallHiddenDate = commonUtils.getLocalStorageObject(Constants.APP_INSTALL_HIDDEN_TODAY);

    if (appInstallHiddenDate) {
      const todayDate = new Date();
      const hiddenDate = new Date(appInstallHiddenDate);
      if (hiddenDate >= todayDate) {
        // 클릭한 시점 >= 현재
        return; // ㅂㅂ
      }
    }

    this.appInstallPromptPop = true;
  }

  btnHome(): void {
    this.menuIdx = 0;
    if (this.$route.name != "Main") {
      this.$router.push({ name: "Main" });
    }
  }

  // 메뉴 타입별 라우터 링크
  getRouterLinkByMenu(menu: MstMenuVO) {
    switch (menu.menuType) {
      case "034001": // 프로모션
        return { name: "Promotion", params: { layoutCd: menu.layoutCd } };
      case "034002": // 메인
        return { name: "Main" };
      case "034003": // 리뷰
        return { name: "BestReviews" };
      case "034004": // 피드
        return { name: "BestFeeds" };
      case "034005": // 래플
        return { name: "Raffles" };
      case "034006": // 톡톡
        return { name: "Talks" };

      default:
        return { name: "Main" };
    }
  }
  // 현재 메뉴임?
  isCurrentMenu(menu: MstMenuVO) {
    switch (menu.menuType) {
      case "034001": // 프로모션
        return this.$route.name == "Promotion" && menu.layoutCd.toString() == this.$route.params.layoutCd;
      case "034002": // 메인
        return this.$route.name == "Main";
      case "034003": // 리뷰
        return this.$route.name == "BestReviews";
      case "034004": // 피드
        return this.$route.name == "BestFeeds";
      case "034005": // 래플
        return this.$route.name == "Raffles";
      case "034006": // 톡톡
        return this.$route.name == "Talks";
      default:
        return false;
    }
  }

  getBannerByType(bannerTypeCd: string) {
    return this.banners.filter((v) => v.bannerTypeCd == bannerTypeCd);
  }

  // 플로팅배너
  swiperfloatingBanners = {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    effect: "fade",
  };

  // 플로팅 배너 닫기 버튼
  btnCloseFloatingBanner(bannerCd: number, temporarilyClose?: boolean) {
    //일반 닫기 버튼 했을 떄 추가 - v 20231109
    temporarilyClose ? true : false;

    const closeBanner = this.banners.find((item) => {
      return item.bannerCd == bannerCd;
    });

    // 닫을게 없음
    if (!closeBanner) {
      return;
    }

    // 배너 객체 삭제
    const closeBannerIndex = this.banners.indexOf(closeBanner);
    this.banners.splice(closeBannerIndex, 1);

    let closedBanners = new Map(CommonUtils.getLocalStorageObject(Constants.MAIN_FLOATING_BANNERS_CLOSED)) as Map<number, number>;
    if (!closedBanners) {
      closedBanners = new Map();
    }
    // 오늘 23시 59분 59초까지
    const temp = new Date(Date.now());
    temp.setHours(23);
    temp.setMinutes(59);
    temp.setSeconds(59);

    //일반 닫기 버튼 했을 떄 추가 - v 20231109
    if(!temporarilyClose){
      closedBanners.set(bannerCd, temp.getTime());
    }
    CommonUtils.putLocalStorageObject(Constants.MAIN_FLOATING_BANNERS_CLOSED, Array.from(closedBanners.entries()));
  }

  // 페이지 이동시 플러팅베너 안보이게
  linkClickedCloseFloatingBanner(bannerCd: number) {
    this.btnCloseFloatingBanner(bannerCd);
    this.isClickedFloatingBanner = true;
  }

  // 안닫힌 플로팅 배너임?
  isNotClosedFloatingBanner(bannerCd: number) {
    const closedBanners = new Map(CommonUtils.getLocalStorageObject(Constants.MAIN_FLOATING_BANNERS_CLOSED)) as Map<number, number>;
    if (!closedBanners) {
      return true; // 안닫힘
    }
    const banner = closedBanners.get(bannerCd);
    // 닫은 배너가 아니면
    if (!banner) {
      return true; // 안닫힘
    }
    // 기한 만료
    if (banner < Date.now()) {
      closedBanners.delete(bannerCd);
      CommonUtils.putLocalStorageObject(Constants.MAIN_FLOATING_BANNERS_CLOSED, Array.from(closedBanners.entries()));
      return true; // 안닫힘
    }
    return false; // 닫힘
  }

  // keep alive 기준
  get routeKey() {
    const result = decodeURI(this.$route.fullPath) + JSON.stringify(this.$route.params) + this.$store.state.keepAliveSeq;
    return result;
  }

  get keepAlive() {
    return this.$route.meta.keepAlive;
  }

  // 전체 메뉴 카테고리 또는 브랜드 선택하면
  @Watch("currentTotalMenu")
  onChangeTotalMenuType(v) {
    // 브랜드 선택하면 카테고리 초기화
    if (v == "02") {
      this.categoryOneDepth = {} as CategoryVO;
      this.categoryTwoDepth = {} as CategoryVO;
      return;
    }
  }
  // 홈화면이동시 플러팅배너 
  @Watch("$route")
  onChangeRoute(to) {
    if(to?.name == "Main"){
      this.flagFloatingBanner();
    }
  }

  // 전체메뉴 중 01: 카테고리, 02: 브랜드
  onClickTotalMenu(menuType: string) {
    this.currentTotalMenu = menuType;
  }

  getBrandsByInitial(initial: string) {
    return this.brands.filter((b) => {
      return (b.brandEngNm || "#").toUpperCase().startsWith(initial);
    });
  }

  // 다음에 보기
  closeNotificationPointPop() {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    CommonUtils.putLocalStorageObject(Constants.NOTIFICATION_POINT_HIDDEN_TODAY, date);
    this.showNotificationPointPopup = false;
  }

  // 포인트 지급 팝업 SHOW / HIDE
  setNotifcationPointPopup(){
    let checknotificationPointPopupDate = true;
    
    // 오늘 하루 보지 않기 클릭 시점
    const notificationPointPopupDate = CommonUtils.getLocalStorageObject(Constants.NOTIFICATION_POINT_HIDDEN_TODAY);

    if (notificationPointPopupDate) {
      const todayDate = new Date();
      const hiddenDate = new Date(notificationPointPopupDate);
      if (hiddenDate >= todayDate) {
        // 클릭한 시점 >= 현재
        checknotificationPointPopupDate = false; 
      }
    }

    // 일반알림, 마케팅 수신알림에 대한 포인트 조회 후 팝업상태 결정
    this.checkNotificationPoint('20', checknotificationPointPopupDate);
    this.checkNotificationPoint('21', checknotificationPointPopupDate);
  }

  // 일반알림, 마케팅 수신알림에 대한 포인트가 지급되었는지 조회하고 그에 따른 팝업 ON/OFF를 결정함
  async checkNotificationPoint(memPointType: string, checknotificationPointPopupDate: boolean){
    const hist: MstPointHistoryVO = {} as MstPointHistoryVO;

    hist.memPointType = memPointType;
    hist.memCd = this.member.memCd;

    // 포인트 발급여부 조회
    //  isSendedNotiPoint[0] : 마케팅 수신동의 (코드 20)
    //  isSendedNotiPoint[1] : 일반알림 수신동의 (코드 21)
    await axios.get('/mypage/profile/point-history',{params : hist}).then(r=>{
      if(r.data.memPointType == '20'){
        this.isSendedNotiPoint[0] = (r.data.regDate == null ? false : true);
        this.mailingType[0] = r.data.status; // as mailingType
        this.sumPoint[0] = r.data.point;
      }
      else if(r.data.memPointType == '21'){
        this.isSendedNotiPoint[1] = (r.data.regDate == null ? false : true);
        this.mailingType[1] = r.data.status; // as mailingType
        this.sumPoint[1] = r.data.point;
      }

      // 조건1 : 마케팅알림 수신동의에 대한 포인트 지급 내역이 없고 마케팅알림 수신동의 OFF 상태
      // 조건2 : 일반알림 수신동의에 대한 포인트 지급 내역이 없고 일반알림 수신동의 OFF 상태
      //
      // * 조건1과 조건2 중 한 가지만이라도 만족 할 경우 포인트 지급 안내 팝업을 표시한다
      this.showNotificationPointPopup = (
        ((!this.isSendedNotiPoint[0]) && (this.mailingType[0] == '02'))||   // 조건1
        ((!this.isSendedNotiPoint[1]) && (this.mailingType[1] == '02'))     // 조건2
      ) ? true : false;

      // 포인트 지급 팝업에 대한 로컬저장값(시간) 체크
      this.showNotificationPointPopup = checknotificationPointPopupDate ? this.showNotificationPointPopup : false;
    });

    return false;
  }


  created(): void {
    // 수신동의
    /* if (CommonUtils.isApp()) {
      this.setNotifcationPointPopup();      
    } */

    // 모바일 웹이면
    if (this.isMobileWeb) {
      // 앱 설치 유도 팝업
      this.initAppInstallPromptPop();
    }

    window.addEventListener("scroll", this.handleScroll);

    /////////////////////////////////
    //////////// PC 웹 //////////////
    /////////////////////////////////
    if (!this.$isMobile) {
      // 메뉴 로드
      !this.$store.state.gnbMenus.length && this.$store.dispatch("selectGnbMenus");
      this.$store.dispatch("updateCartCount");
      // 상단 메뉴 고정 초기화
      this.$store.commit("isTopMenuFixed", false);

      // 카테고리 조회
      axios.get("/categories").then((r) => {
        this.categories = r.data as Array<CategoryVO>;
      });
      // 브랜드
      axios.get("/brands").then((r) => {
        this.brands = r.data as Array<BrandVO>;
      });
    }

    // 배너 로드
    axios.get("/banners").then((r) => {
      this.banners = r.data;
    });

    // 채팅문의(글로벌)
    if (channel) {
      let language = process.env.VUE_APP_I18N_LOCALE || "en";

      // en, ko, ja 만 가능
      const allowLanguages = ["en", "ko", "ja"];

      if (allowLanguages.includes(language) == false) {
        language = "en";
      }

      const settings = {
        pluginKey: process.env.VUE_APP_CHANNEL_IO_PLUGIN_KEY,
        customLauncherSelector: ".customer_center",
        hideChannelButtonOnBoot: true,
        language: language,
        hidePopup: true,
      };

      // 로그인했다면
      if (this.member) {
        Object.assign(settings, {
          memberId: this.member.memCd,
          profile: {
            name: this.member.memNm,
            mobileNumber: this.member.memPh,
            email: this.member.memEmail,
            avatarUrl: this.member.memProfileFileUrl,
          },
        });
      }

      channel.boot(settings);
    }
  }

  getChildCateCds(parentCateCd: number | null): Array<CategoryVO> {
    // 자식 category 반환
    const result = this.categories.filter((category) => {
      if (!parentCateCd) {
        return category.cateDepth == 1;
      } else {
        return category.parentCateCd == parentCateCd;
      }
    });
    return result;
  }

  onMouseOverForCategory(category: CategoryVO): void {
    if (category.cateDepth == 1) {
      this.onClickTotalMenu("01");
      this.categoryOneDepth = category;
    }

    if (category.cateDepth == 2) {
      this.categoryTwoDepth = category;
    }
  }

  // 전체 메뉴 닫기
  onMouseLeaved() {
    this.openedTotalMenu = false;

    // 초기화
    this.currentTotalMenu = "";
    this.categoryOneDepth = {} as CategoryVO;
    this.categoryTwoDepth = {} as CategoryVO;
    this.currentInitial = "";
  }

  beforeDestory() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  //로그아웃
  doLogout(): void {
    CommonUtils.logout(this).then((r) => {
      if (r != undefined) {
        if (channel) channel.logout();
      }
    });
  }

  // 플러팅배너 상태
  flagFloatingBanner(): void {
    if(this.floatingBanners.length > 0) {
      this.isClickedFloatingBanner = false;
    } else {
      this.isClickedFloatingBanner = true;
    }
  }
}
